module.exports = __webpack_public_path__ + "static/media/print3.356e6def.jpg";